import { render, staticRenderFns } from "./time-format-editor.vue?vue&type=template&id=ee4aa0b6&scoped=true"
import script from "./time-format-editor.vue?vue&type=script&lang=js"
export * from "./time-format-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4aa0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee4aa0b6')) {
      api.createRecord('ee4aa0b6', component.options)
    } else {
      api.reload('ee4aa0b6', component.options)
    }
    module.hot.accept("./time-format-editor.vue?vue&type=template&id=ee4aa0b6&scoped=true", function () {
      api.rerender('ee4aa0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-time/time-format-editor.vue"
export default component.exports